export type UhfData = Readonly<{
  cssIncludes: string;
  javascriptIncludes: string;
  headerHtml: string;
  footerHtml: string;
}>;

export enum UhfHeaderMode {
  Full = "Full",
  Minimal = "Minimal",
  Hidden = "Hidden",
  None = "None",
  Off = "Off",
}

export enum UhfFooterMode {
  Full = "Full",
  Minimal = "Minimal",
  Hidden = "Hidden",
  None = "None",
  Off = "Off",
}

export type UhfConfig = {
  headerMode?: UhfHeaderMode;
  footerMode?: UhfFooterMode;
};

export type UhfConfigGeneratorFn = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ...args: any[]
) => Generator<unknown, Readonly<UhfConfig>, unknown>;

export type RouteUhfConfig = Readonly<UhfConfig> | UhfConfigGeneratorFn;
